import Vue from 'vue'
import VueRouter from 'vue-router'
import HomePage from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: HomePage,
    meta: {
      title: 'Home | CAADLab | Computer Architecture and Automated Design Lab',
      metaTags: [
        {

        }
      ]
    }
  },
  {
    path: '/research',
    name: 'ResearchPage',
    component: () => import('../views/Research.vue'),
    meta: {
      title: 'Research | CAADLab | Computer Architecture and Automated Design Lab',
      metaTags: [
        {

        }
      ]
    }
  },
  {
    path: '/people',
    name: 'PeoplePage',
    component: () => import('../views/People.vue'),
    meta: {
      title: 'People | CAADLab | Computer Architecture and Automated Design Lab',
      metaTags: [
        {

        }
      ]
    }
  },
  {
    path: '/publications',
    name: 'PublicationsPage',
    component: () => import('../views/Publications.vue'),
    meta: {
      title: 'Publications | CAADLab | Computer Architecture and Automated Design Lab',
      metaTags: [
        {

        }
      ]
    }
  },
  {
    path: '/courses',
    name: 'CoursesPage',
    component: () => import('../views/Courses.vue'),
    meta: {
      title: 'Courses | CAADLab | Computer Architecture and Automated Design Lab',
      metaTags: [
        {

        }
      ]
    }
  },
  {
    path: '/joinus',
    name: 'JoinUs',
    component: () => import('../views/Join.vue'),
    meta: {
      title: 'Join Us | CAADLab | Computer Architecture and Automated Design Lab',
      metaTags: [
        {

        }
      ]
    }
  },
  {
    path: '*',
    name: 'Catchall',
    redirect: '/'
  }
]


const router = new VueRouter({
  // mode: 'history',
  // base: process.env.BASE_URL,
  routes,
});

const DEFAULT_TITLE = 'CAADLab | Computer Architecture and Automated Design Lab'

router.afterEach((to) => {
    // Use next tick to handle router history correctly
    // see: https://github.com/vuejs/vue-router/issues/914#issuecomment-384477609
    Vue.nextTick(() => {
        document.title = to.meta.title || DEFAULT_TITLE;
    });
});

export default router
